import React from 'react'
import { RxTriangleRight } from 'react-icons/rx'
import { useNavigate } from 'react-router-dom'
import styles from "./Approach.module.css"

function Service() {
  const Navigate = useNavigate()

  return (
    <div className={styles.approach} style={{ background: '#fff' }}>
      <h3 style={{ color: "#066263" }}>APPROACH</h3>
      <div className={styles.approachbody}>

        <div className={styles.MobileContainer}>

          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox1} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >顧客を取り巻く環境のリサーチ。</p>
          </div>

          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox2} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >解決すべき問題を見極める。</p>
          </div>

          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox3} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >最もシンプルに問題を解決する方法 <br /> を数パターン準備し検証。</p>
          </div>

          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox4} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >最も適したと判断できる解決策を実行。</p>
          </div>

          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox5} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >解決策の結果の検証と修正。</p>
          </div>
        </div>

        <div className={styles.appGridContainer}>
          <div className={`${styles.approachbodyText} ${styles.mobileview}`}>
            <p>現状把握</p>
          </div>
          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox1} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >顧客を取り巻く環境のリサーチ。</p>
          </div>
          <div className={`${styles.approachbodyText} ${styles.mobileview}`}>
            <p>問題の定義</p>
          </div>
          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox2} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >解決すべき問題を見極める。</p>
          </div>
          <div className={`${styles.approachbodyText} ${styles.mobileview}`}>
            <p>解決策の設計</p>
          </div>
          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox3} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >最もシンプルに問題を解決する方法 <br /> を数パターン準備し検証。</p>
          </div>
          <div className={`${styles.approachbodyText} ${styles.mobileview}`}>
            <p>解決策の実行</p>
          </div>
          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox4} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >最も適したと判断できる解決策を実行。</p>
          </div>
          <div className={`${styles.approachbodyText} ${styles.mobileview}`}>
            <p>検証・修正</p>
          </div>
          <div className={styles.approachDivs}>
            <div data-aos="slide-right" className={`${styles.approachDivsbox5} ${styles.rotatecenter}`}>

            </div>
            <div className={styles.approachDivsline1}>

            </div>
          </div>
          <div className={styles.description}>
            <p >解決策の結果の検証と修正。</p>
          </div>
        </div>

      </div>
      <div className={`${styles.WwhyUsbutton} mobileButton`}>
        <button onClick={() => Navigate('/approaches')}> Approach<RxTriangleRight /> </button>

      </div>
    </div>
  )
}

export default Service